import clsx from "classnames";
import classes from "./styles.module.scss";
import Link from 'next/link';
import { useRouter } from 'next/router';
import SourceFlowForm from "@sourceflow-uk/sourceflowform";
import SourceFlowApplicationForm from "@sourceflow-uk/sourceflowapplicationform";
import { formatDistanceToNow, fromUnixTime } from 'date-fns';
import { getSpecialisms } from "@/functions/getSpecialisms";
import { getContractType } from "@/functions/getContractType";

export default function JobDetail({ className, job, consultant }) {

  const router = useRouter();
  const pathName = 'https://www.xcede.com' + router.asPath;

  var timeAgo = ''
  const createdAtDate = fromUnixTime(job.created_at);
  if (createdAtDate instanceof Date && !isNaN(createdAtDate)) {
    timeAgo = formatDistanceToNow(new Date(createdAtDate), { addSuffix: true });
  } else {
    timeAgo = formatDistanceToNow(new Date(job.created_at), { addSuffix: true });
  }

  function formatDate(date) {
    const inputDate = new Date(date);

    const day = inputDate.getDate().toString().padStart(2, '0');
    const month = (inputDate.getMonth() + 1).toString().padStart(2, '0'); // Month is zero-based
    const year = inputDate.getFullYear();

    const formattedDate = `${day}/${month}/${year}`;
    return formattedDate
  }

  return (
    <div className={clsx(className, classes.job)}>
      <div className={classes.job_posting}>
        <div className={classes.job_specification}>
          <h1 className={classes.job_title}>{job.title}</h1>
          <div className={classes.job_info}>
            <div className={classes.info_item}>
              <div className={classes.info_label}>Location:</div>
              <div className={classes.info_value}>{job.location}</div>
            </div>
            <div className={classes.info_item}>
              <div className={classes.info_label}>Salary:</div>
              <div className={classes.info_value}>{job.salary_package}</div>
            </div>
            <div className={classes.info_item}>
              <div className={classes.info_label}>Job Type:</div>
              <div className={classes.info_value}>{getContractType(job.categories)}</div>
            </div>
            <div className={classes.info_item}>
              <div className={classes.info_label}>Date Posted:</div>
              <div className={classes.info_value}>{timeAgo}</div>
            </div>
            <div className={classes.info_item}>
              <div className={classes.info_label}>Expiry Date:</div>
              <div className={classes.info_value}>{formatDate(job.expires_at)}</div>
            </div>
            <div className={classes.info_item}>
              <div className={classes.info_label}>Job Ref:</div>
              <div className={classes.info_value}>{job.external_reference}</div>
            </div>
            <div className={classes.info_item}>
              <div className={classes.info_label}>Start Date:</div>
              <div className={classes.info_value}>{formatDate(job.published_at)}</div>
            </div>
            <div className={classes.info_item}>
              <div className={classes.info_label}>Contact:</div>
              <div className={classes.info_value}>{consultant?.name}</div>
            </div>
            <div className={classes.info_item}>
              <div className={classes.info_label}>Contact Email:</div>
              <div className={classes.info_value}>{consultant?.email}</div>
            </div>
            <div className={classes.info_item}>
              <div className={classes.info_label}>Specialism:</div>
              <div className={classes.info_value}>{getSpecialisms(job.categories)}</div>
            </div>
          </div>
        </div>      
        <div className={classes.job_description}>
          <div dangerouslySetInnerHTML={{ __html: job.description }}/>
        </div>  
        <div id="job_application" className={classes.job_application}>
          {/* Add Job Application form here */}
          <h3 className={classes.title}>APPLY FOR THIS JOB</h3>
          <div className={classes.subtitle}>For your job application, please fill in the form below.</div>
          <SourceFlowApplicationForm
            onSubmitDone={() => (window.location.href = '/jobs/thank-you-for-applying')}
            jobId={job.id}
          />
        </div>        
      </div>
      <div className={classes.job_additional}>
        <div>
          <a href="#job_application">
            <button className={classes.apply_button}>Apply Now</button>        
          </a>
          <div className={classes.social_sharing}>
            <div className={classes.label}>SHARE THIS JOB</div>
            <div className={classes.socials}>
              <a href={"https://wa.me/?text=Check%20out%20this%20link:%20" + pathName} target="_blank" rel="nofollow">
                <img alt="whatsapp" src="/icons/whatsapp.svg" width="38" height="38" className={classes.icon}></img>
              </a>
              <a href={"mailto:?body=" + pathName} target="_blank" rel="nofollow">
                <img alt="envelope" src="/icons/envelope.svg" width="38" height="38" className={classes.icon}></img>
              </a>
              <a href={"https://www.linkedin.com/sharing/share-offsite/?url=" + pathName} target="_blank" rel="nofollow">
                <img alt="linkedin" src="/icons/linkedin.svg" width="38" height="38" className={classes.icon}></img>
              </a>
            </div>
          </div>    
        </div>
           
        <div className={classes.job_consultant}>
          <Link href={"/consultants/" + consultant.url_slug} passHref>
            <img alt={consultant.name} src={consultant.profile_image ?? '/profile_placeholder.jpg'} width="100" height="100" className={classes.profile_img}></img>
          </Link>
          <div>
            <Link href={"/consultants/" + consultant.url_slug} passHref>
              <h4 className={classes.name}>{consultant.name}</h4>
            </Link>
            {consultant?.specialisms && (
              <div className={classes.specialty}>Specialisms: {(consultant?.specialisms ?? []).join(", ")}</div>
            )}
          </div>
          <div className={classes.socials}>
            <a href={"https://wa.me/" + consultant.phone} target="_blank" rel="nofollow">
                <img alt="whatsapp" src="/icons/whatsapp.svg" width="32" height="32" className={classes.icon}></img>
              </a>
              <a href={"mailto:" + consultant.email} target="_blank" rel="nofollow">
                <img alt="envelope" src="/icons/envelope.svg" width="32" height="32" className={classes.icon}></img>
              </a>
              <a href={consultant.linkedin} target="_blank" rel="nofollow">
                <img alt="linkedin" src="/icons/linkedin.svg" width="32" height="32" className={classes.icon}></img>
              </a>
          </div>
        </div>        
        {/* <div className={classes.job_alerts}>
        </div>         */}
      </div>
    </div>
  );
}

JobDetail.defaultProps = {
  className: "",
};
